module.exports = __webpack_public_path__ + "static/img/6.f60f2f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/eng/6.png
// module id = 3iXF
// module chunks = 0